import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { user } from './user';
import { localization } from './localization';
import dashboard from '../scenes/Dashboard/reducers';
import settings from '../scenes/Settings/reducers';
import { requestBuilder } from '../scenes/RequestBuilder/reducers';
import contactProfile from '../scenes/ContactProfile/reducers';
import { positionProfile } from '../scenes/PositionProfile/reducers';
import { owners } from '../containers/OwnerList/reducer';
import { teamList } from '../containers/TeamList/reducer';
import { referenceRequest } from '../scenes/CandidateForm/reducers';
import { refSurvey } from '../scenes/SurveyUI/reducers';
import { surveyBuilder } from '../scenes/SurveyBuilder/reducers';
import { globalSearch } from '../scenes/GlobalSearch/reducer';
import { report } from '../containers/ShareReportModal/reducer';
import { choosePosition } from '../containers/ChoosePositionPage/reducer';
import { mergePositions } from '../containers/MergePositions/reducer';
import { mergeContacts } from '../containers/MergeContacts/reducer';
import { sendReminder } from '../containers/SendReminderModal/reducer';
import { workspace } from './workspace';

const rootReducer = (history: History) => combineReducers({
  router: connectRouter(history),
  user,
  dashboard,
  localization,
  contactProfile,
  positionProfile,
  requestBuilder,
  owners,
  teamList,
  referenceRequest,
  refSurvey,
  surveyBuilder,
  globalSearch,
  settings,
  report,
  choosePosition,
  mergePositions,
  mergeContacts,
  sendReminder,
  workspace
});

export default rootReducer;
